import {DOM} from "../../../../public/js/utils/DOM";

export namespace DropDownControl {

    class Config {
        public static readonly activeClassName = "active";
        public static readonly dropDownItemClassName = "DropDownControl-content-dropdown-inside-item";
        public static readonly valueDataName = "value";
        public static readonly activeItemClassName = "activeItem";
        public static readonly dropDownClassName = "DropDownControl-content-dropdown";
    }

    export class Control {

        public static trigger(dropdownId: string, changeCallback: (valueToPropagate: string|null|number, event: MouseEvent) => void) {

            const dropDownElement = DOM.Parser.getHtmlElement(dropdownId);
            this.triggerHideOnOutsideClick(dropdownId);
            this.triggerDropDown(dropDownElement);
            this.triggerChange(dropDownElement, changeCallback);
        }

        /**
         * Todo remove event when destructing
         * @param dropdownId - id of dropdown element
         * @private
         */
        private static triggerHideOnOutsideClick(dropdownId: string) : void {

            window.addEventListener('click', (evt: MouseEvent) => {

                const dropDownElement: HTMLElement|null = document.getElementById(dropdownId);
                if (dropDownElement === null || !dropDownElement.classList.contains(Config.activeClassName)) { return; }
                const clickedInside = DOM.Parser.parentContainsTheClass(Config.dropDownClassName, evt.target as HTMLElement);
                if (clickedInside) { return; }
                dropDownElement.classList.remove(Config.activeClassName);
            });
        }

        public static getCurrentDropDownValue(dropdownId: string) : string|null|number {

            const dropDownElement = DOM.Parser.getHtmlElement(dropdownId);
            const activeItem = DOM.Parser.getHtmlElementByClass(Config.activeItemClassName, dropDownElement) as HTMLInputElement;
            const value = DOM.Parser.getDataByNameFromElementOrNull(Config.valueDataName, activeItem);
            return (value && Number.isNaN(value) ? parseInt(value) : value) ?? null;
        }

        private static triggerDropDown(dropDownElement: HTMLElement) : void {

            dropDownElement.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault(); event.stopPropagation();
                dropDownElement.classList.toggle(Config.activeClassName);
            })
        }

        private static triggerChange(dropDownElement: HTMLElement, changeCallback: (valueToPropagate: string|null|number, event: MouseEvent) => void) : void {

            const triggers = DOM.Parser.getHtmlElements(Config.dropDownItemClassName, dropDownElement);
            for (let i = 0; i < triggers.length; i++) {
                const trigger = triggers[i];
                trigger.addEventListener('click', (event: MouseEvent) => {
                    event.stopPropagation(); event.preventDefault();
                    const valueToPropagate = DOM.Parser.getDataByNameFromElementOrNull(Config.valueDataName, trigger);
                    changeCallback(valueToPropagate, event);
                });
            }
        }
    }
}